const lazy = path => () => import(`./${path}`);

// 领取
export default [
  // 日结审核详情
  {
    path: "/advanceV2/index",
    name: "advanceV2Index",
    component: lazy("index"),
    meta: {
      title: "预支工资",
      keepAlive: false
    }
  },
  {
    path: "/advanceV2/advanceSuccess",
    name: "AdvanceV2Success",
    component: lazy("advanceSuccess"),
    meta: {
      title: "预支成功",
      keepAlive: true
    }
  },
  {
    path: "/advanceV2/advanceRecord",
    name: "AdvanceV2Record",
    component: lazy("advanceRecord"),
    meta: {
      title: "预支记录",
      keepAlive: false
    }
  },
  {
    path: "/advanceV2/advanceSure/:applyBizNo?",
    name: "AdvanceV2Sure",
    component: lazy("advanceSure"),
    meta: {
      title: "预支申请",
      keepAlive: true
    }
  }
];
